import { render } from "./CZLastBillDateWater.vue?vue&type=template&id=0c8bf3b4&ts=true"
import script from "./CZLastBillDateWater.vue?vue&type=script&lang=ts"
export * from "./CZLastBillDateWater.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Devlop\\C-Zone-v1\\UI_EICPartnership\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__